export const VYJEZD_CREW_OPTIONS = [
  "Stanko",
  "Novák",
  "Maxa",
  "Knížek",
  "Lisý",
  "Burian",
  "Cimerhanzl",
];

export const VYJEZD_STORAGE_TYPES = [
  { id: "soudni_pitva", label: "Soudní pitva" },
  { id: "zdravotni_pitva", label: "Zdravotní pitva" },
  { id: "chladnice", label: "Chladnice" },
];

export const TRANSPORT_PLACES = [
  {
    id: "cb_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Soudnělékařské oddělení Nemocnice České Budějovice",
    address: "B. Němcové 585/54, 370 01 České Budějovice",
    city: "České Budějovice",
    note: "Jihočeský kraj",
  },
  {
    id: "cb_patologie",
    types: ["zdravotni_pitva"],
    name: "Patologické oddělení Nemocnice České Budějovice",
    address: "B. Němcové 585/54, 370 01 České Budějovice",
    city: "České Budějovice",
    note: "Patologie",
  },
  {
    id: "ck_chladnice",
    types: ["chladnice"],
    name: "Chladicí zařízení Český Krumlov",
    address: "Pod Skládkou 525, Český Krumlov",
    city: "Český Krumlov",
    note: "Interní chladnice",
  },
  {
    id: "plzen_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Ústav soudního lékařství Plzeň",
    address: "Alej Svobody 923/80, 323 00 Plzeň",
    city: "Plzeň",
    note: "",
  },
  {
    id: "praha_vfn_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Ústav soudního lékařství VFN Praha",
    address: "Ke Karlovu 2, 128 00 Praha 2",
    city: "Praha",
    note: "",
  },
  {
    id: "praha_uvn_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Vojenský ústav soudního lékařství Praha",
    address: "U Vojenské nemocnice 1200, 169 02 Praha 6",
    city: "Praha",
    note: "ÚVN",
  },
  {
    id: "usti_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Soudní lékařství a toxikologie Ústí nad Labem",
    address: "Sociální péče 3316/12A, 401 13 Ústí nad Labem",
    city: "Ústí nad Labem",
    note: "",
  },
  {
    id: "liberec_soudni",
    types: ["soudni_pitva", "zdravotni_pitva"],
    name: "Oddělení soudního lékařství Liberec",
    address: "Husova 357/10, 460 01 Liberec",
    city: "Liberec",
    note: "",
  },
  {
    id: "brno_soudni",
    types: ["soudni_pitva"],
    name: "Ústav soudního lékařství Brno",
    address: "Tvrdého 562/2A, 662 99 Brno",
    city: "Brno",
    note: "",
  },
  {
    id: "ostrava_soudni",
    types: ["soudni_pitva"],
    name: "Ústav soudního lékařství Ostrava",
    address: "17. listopadu 1790, 708 52 Ostrava-Poruba",
    city: "Ostrava",
    note: "",
  },
];

export function getTransportPlacesByType(type) {
  const key = String(type || "").trim();
  if (!key) return [];
  return TRANSPORT_PLACES.filter((item) => Array.isArray(item.types) && item.types.includes(key));
}

export function getTransportPlaceById(id) {
  const key = String(id || "").trim();
  if (!key) return null;
  return TRANSPORT_PLACES.find((item) => String(item.id || "").trim() === key) || null;
}
